import { Box, MenuItem, TextField, Typography } from '@mui/material';

import { Heading2 } from '../../components/Heading';
import { WINDOW_OPTIONS } from './constants';
import { formatDate } from './format';

const PerformanceHeader = ({
  headline,
  asOf,
  windowWeeks,
  onWindowChange,
  isUpdating,
  title = 'My Performance',
  sharedBy,
}) => (
  <Box sx={{ mb: 3 }}>
    <Heading2 sx={{ fontSize: { xs: 30, tl: 40 } }}>{title}</Heading2>
    {sharedBy && (
      <Typography sx={{ mt: 1, fontSize: 14, opacity: 0.85 }}>Shared by {sharedBy}</Typography>
    )}
    {headline && (
      <Typography sx={{ mt: 2, fontSize: { xs: 17, tl: 20 }, maxWidth: 760 }}>
        {headline}
      </Typography>
    )}
    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
      <TextField
        select
        size="small"
        label="Time window"
        value={windowWeeks}
        onChange={(event) => onWindowChange(Number(event.target.value))}
        sx={{ minWidth: 150 }}
      >
        {WINDOW_OPTIONS.map((weeks) => (
          <MenuItem key={weeks} value={weeks}>
            Last {weeks} weeks
          </MenuItem>
        ))}
      </TextField>
      <Typography sx={{ fontSize: 13, opacity: 0.7 }} role="status">
        {isUpdating ? 'Updating...' : asOf ? `Updated ${formatDate(asOf)}` : ''}
      </Typography>
    </Box>
  </Box>
);

export default PerformanceHeader;
